import { FC } from 'react';

const ActionIconArrowRightSmall: FC = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.00012207 4.986H8.94412L6.32812 1.631L7.90612 0.4L11.7891 5.382C12.0711 5.743 12.0701 6.25 11.7891 6.611L7.90512 11.588L6.32912 10.357L8.96012 6.986H0.00012207V4.986Z"
      fill="currentColor"
    />
  </svg>
);

export { ActionIconArrowRightSmall };
